import React, { useState, useEffect } from 'react';
import { API_URL, secret_key, storedData } from '../Constants';
import axios from 'axios';
import Swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import loadingGif from "../../assets/loading.gif";
import './Dashboard.css';

const Dashboard = () => {
  const navigate = useNavigate();

  // --- Decrypt User Token and Data ---
  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';
  if (encryptedToken) {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error('Token decryption error:', error);
    }
  }
  const token = `Bearer ${decryptedToken}`;

  let loggedUserData = null;
  if (storedData) {
    const bytes = CryptoJS.AES.decrypt(storedData, secret_key);
    loggedUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  // --- State Declarations ---
  const [credits, setCredits] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [totalMessages, setTotalMessages] = useState(1);
  const [inputValue, setInputValue] = useState('');

  const [topTodaySenders, setTopTodaySenders] = useState([]);
  const [topYesterdaySenders, setTopYesterdaySenders] = useState([]);

  
  const [onfonBalance, setOnfonBalance] = useState(0);

  const [companyData, setCompanyData] = useState({
    api_key: "",
    city_id: "",
    city_name: "",
    created_at: "",
    id: "",
    name: "",
    onfon_sender_id: "",
    rate: "",
    sender_id: "",
    sms_provider: "",
    units: 0,
    updated_at: "",
    vas_email: ""
  });

  const [totalSpend, setTotalSpend] = useState(0);
  const [smsStats, setSmsStats] = useState({});
  const [smsData, setSmsData] = useState({
    phone_no: [],
    subject: "",
    message_body: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // --- API Fetch Functions ---

  const fetchCreditHistory = () => {
    axios.get(`${API_URL}/get_credit_history/${loggedUserData?.company_id}`, {
      headers: { Authorization: token }
    })
      .then(response => setCredits(response.data))
      .catch(error => console.error("Credit history fetch error:", error));
  };

  const fetchTopSenderIdsToday = () => {
    axios.get(`${API_URL}/get_top_senderids_today`, {
      headers: { Authorization: token }
    })
      .then(response => setTopTodaySenders(response.data))
      .catch(error => console.error("Today's top sender fetch error:", error));
  };

  const fetchTopSenderIdsYesterday = () => {
    axios.get(`${API_URL}/get_top_senderids_yesterday`, {
      headers: { Authorization: token }
    })
      .then(response => setTopYesterdaySenders(response.data))
      .catch(error => console.error("Yesterday's top sender fetch error:", error));
  };

  const fetchVendorBalances = () => {
    if (loggedUserData?.role_id === 4) {
      axios.get(`${API_URL}/get_onfon_bal`, {
        headers: { Authorization: token }
      })
        .then(response => setOnfonBalance(response.data))
        .catch(error => console.error("Onfon balance error:", error));
    }
  };

  const fetchCompanyByID = () => {
    axios.get(`${API_URL}/get_company/${loggedUserData?.company_id}`, {
      headers: { Authorization: token }
    })
      .then(response => setCompanyData(response.data))
      .catch(error => {
        if (error?.response?.status === 401) navigate(0);
      });
  };

  const fetchTotalSpend = () => {
    axios.get(`${API_URL}/get_spent_stats/${loggedUserData?.company_id}`, {
      headers: { Authorization: token }
    })
      .then(response => setTotalSpend(response.data.total_spend))
      .catch(error => console.error("Total spend fetch error:", error));
  };

  const fetchSmsStats = () => {
    axios.get(`${API_URL}/get_sms_stats/${loggedUserData?.company_id}`, {
      headers: { Authorization: token }
    })
      .then(response => setSmsStats(response.data))
      .catch(error => {
        if (error?.response?.status === 401) navigate(0);
      });
  };

  const fetchContacts = () => {
    const url = `${API_URL}/get_contacts_bycompanyid/${loggedUserData?.company_id}?page=1&limit=1000000`;
    axios.get(url, { headers: { Authorization: token } })
      .then(response => {
        const options = response.data.map(contact => ({
          value: contact.phone_no,
          label: `${contact.phone_no} - ${contact.full_name}`
        }));
        setContacts(options);
      })
      .catch(error => {
        if (error?.response?.status === 401) navigate(0);
      });
  };

  // --- Effects ---
  useEffect(() => {
    fetchCreditHistory();
    fetchTopSenderIdsToday();
    fetchTopSenderIdsYesterday();
    fetchVendorBalances();
    fetchCompanyByID();
    fetchTotalSpend();
    fetchSmsStats();
    fetchContacts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const charsPerMessage = 163;
    const messageLength = smsData.message_body.length;
    const messagesNeeded = messageLength > 0 ? Math.ceil(messageLength / charsPerMessage) : 1;
    setTotalMessages(messagesNeeded);
  }, [smsData.message_body]);

  // --- SMS Handling ---
  const handleInputChange = (newValue) => {
    setInputValue(newValue);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      const newNumber = inputValue.trim();
      if (newNumber && newNumber.length > 8 && !smsData.phone_no.includes(newNumber)) {
        setSmsData(prev => ({
          ...prev,
          phone_no: [...prev.phone_no, newNumber]
        }));
        setInputValue('');
      }
    }
  };

  const handleSmsChange = (e) => {
    setSmsData({ ...smsData, [e.target.id]: e.target.value });
  };

  const sendSMS = (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    const formData = {
      phone_no: smsData.phone_no,
      message_subject: smsData.subject,
      message_body: smsData.message_body,
      rate: companyData.rate,
      company_id: loggedUserData?.company_id,
      sender_id: loggedUserData?.sender_id,
      sms_provider: loggedUserData?.sms_provider
    };

    axios.post(`${API_URL}/postSingleSMS`, formData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: token
      }
    })
      .then(response => {
        setIsSubmitting(false);
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Message sent successfully"
        }).then(() => navigate(0));
      })
      .catch(error => {
        setIsSubmitting(false);
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error?.response?.data
        });
      });
  };

  // --- Calculate Remaining Characters ---
  const calculateRemainingCharacters = () => {
    const charsPerSegment = 163;
    const used = smsData.message_body.length % charsPerSegment;
    return {
      totalSegments: totalMessages,
      remaining: used === 0 && smsData.message_body.length !== 0 ? 0 : charsPerSegment - used
    };
  };

  const { totalSegments, remaining } = calculateRemainingCharacters();

  // --- JSX Rendering ---
  return (
    <div className="dashboard-container container-fluid">
  {/* Loading Overlay */}
  {isSubmitting && (
    <div className="loading-overlay d-flex align-items-center justify-content-center">
      <img className="loading-img" src={loadingGif} alt="Loading..." />
    </div>
  )}

  {/* Header */}
  <header className="dashboard-header py-3 border-bottom mb-4">
    <div className="d-flex justify-content-between align-items-center">
      <h1 className="mb-0">Dashboard</h1>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item"><a href="/">Home</a></li>
          <li className="breadcrumb-item active" aria-current="page">Dashboard</li>
        </ol>
      </nav>
    </div>
  </header>

  <div className="row">
    {/* Left Column */}
    <div className="col-lg-8">
      {/* Stat Cards */}
      <div className="row">
      <div className="row mb-4">
        {[
          {
            label: 'Units Bought',
            value: companyData.total_bought,
            icon: 'fas fa-cart-plus',
            gradient: 'bg-gradient-info',
            textColor: 'text-info',
          },
          {
            label: 'Units Spent',
            value: companyData.units_spent,
            icon: 'fas fa-burn',
            gradient: 'bg-gradient-danger',
            textColor: 'text-danger',
          },
          {
            label: 'Units Balance',
            value: companyData.units,
            icon: 'fas fa-balance-scale',
            gradient: 'bg-gradient-success',
            textColor: 'text-success',
          },
          {
            label: 'Rate Per SMS',
            value: `Ksh. ${companyData.rate}`,
            icon: 'fas fa-money-bill-wave',
            gradient: 'bg-gradient-warning',
            textColor: 'text-warning',
          },
          {
            label: 'Total Spent',
            value: `Ksh. ${companyData.total_spend}`,
            icon: 'fas fa-coins',
            gradient: 'bg-gradient-danger',
            textColor: 'text-danger',
          },
        ].map((item, idx) => (
          <div className="col-md-6 col-xl-4 mb-4" key={idx}>
            <div className={`card shadow-lg border-0 rounded-3 h-100 ${item.gradient} text-white`}>
              <div className="card-body d-flex align-items-center">
                <div className="me-3">
                  <div className={`icon-circle bg-white ${item.textColor} shadow-sm mb-2`}>
                    <i className={`${item.icon} fa-lg`}></i>
                  </div>
                </div>
                <div>
                  <h6 className="text-uppercase fw-bold mb-1">{item.label}</h6>
                  <h3 className="fw-bold mb-0">{item.value}</h3>
                </div>
              </div>
            </div>
          </div>
        ))}
</div>


<div className="row mb-4">
  {/* Sent Today */}
  <div className="col-md-4 mb-4">
    <div className="card shadow-lg border-0 rounded-3 h-100 bg-gradient-primary text-white">
      <div className="card-body d-flex align-items-center">
        <div className="me-3">
          <div className="icon-circle bg-white text-primary shadow-sm mb-2">
            <i className="fas fa-calendar-day fa-lg"></i>
          </div>
        </div>
        <div>
          <h6 className="text-uppercase fw-bold mb-1">Sent Today</h6>
          <h3 className="fw-bold mb-0">{smsStats.total_sent_today}</h3>
        </div>
      </div>
    </div>
  </div>

  {/* Sent Yesterday */}
  <div className="col-md-4 mb-4">
    <div className="card shadow-lg border-0 rounded-3 h-100 bg-gradient-warning text-white">
      <div className="card-body d-flex align-items-center">
        <div className="me-3">
          <div className="icon-circle bg-white text-warning shadow-sm mb-2">
            <i className="fas fa-calendar-minus fa-lg"></i>
          </div>
        </div>
        <div>
          <h6 className="text-uppercase fw-bold mb-1">Sent Yesterday</h6>
          <h3 className="fw-bold mb-0">{smsStats.total_sent_yesterday}</h3>
        </div>
      </div>
    </div>
  </div>

  {/* Sent All Time */}
  <div className="col-md-4 mb-4">
    <div className="card shadow-lg border-0 rounded-3 h-100 bg-gradient-success text-white">
      <div className="card-body d-flex align-items-center">
        <div className="me-3">
          <div className="icon-circle bg-white text-success shadow-sm mb-2">
            <i className="fas fa-sms fa-lg"></i>
          </div>
        </div>
        <div>
          <h6 className="text-uppercase fw-bold mb-1">Sent All Time</h6>
          <h3 className="fw-bold mb-0">{smsStats.sms_count}</h3>
        </div>
      </div>
    </div>
  </div>
</div>


      </div>

      {/* Role ID 4 Stats */}
      {loggedUserData?.role_id === 4 && (
        <div className="row">
          {[{
            title: "Today's Top Bulk Sender IDs", data: topTodaySenders, key: 'total_sent_today'
          }, {
            title: "Yesterday's Top Bulk Sender IDs", data: topYesterdaySenders, key: 'total_sent_yesterday'
          }].map((section, idx) => (
            <div className="col-md-6 mb-4" key={idx}>
              <div className="card shadow-sm">
                <div className="card-header">
                  <h5 className="mb-0">{section.title}</h5>
                </div>
                <div className="card-body p-0">
                 <div className="table-responsive">
                  <table className="table table-striped mb-0">
                    <thead>
                      <tr>
                        <th>Sender ID</th>
                        <th>Total SMS</th>
                        <th>Units Bal</th>
                      </tr>
                    </thead>
                    <tbody>
                      {section.data.map((item, i) => (
                        <tr key={i}>
                          <td>{item.sender_id}</td>
                          <td>{item[section.key]}</td>
                          <td>{item.units_bal}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {/* Vendor Balances */}
          <div className="col-md-12 mb-4">
            <div className="card shadow-sm">
              <div className="card-header">
                <h5 className="mb-0">SMS Vendor Balances</h5>
              </div>
              <div className="card-body p-0">
               <div className="table-responsive">
                <table className="table table-striped mb-0">
                  <thead>
                    <tr><th>Provider</th><th>Balance</th></tr>
                  </thead>
                  <tbody>
                    <tr><td>Onfon</td><td>{parseFloat(onfonBalance).toFixed(2)}</td></tr>
                  </tbody>
                </table>
               </div>
              </div>
            </div>
          </div>
        </div>
      )}

{/* Credit History */}
<div className="card shadow-sm mb-4">
  <div className="card-header">
    <h3 className="mb-0"><i className="fas fa-chart-pie mr-2"></i>Credit History</h3>
  </div>
  <div className="card-body p-0">
    <div className="table-responsive">
      <table className="table table-striped mb-0">
        <thead>
          <tr>
            <th>Date</th>
            <th>Reference</th>
            <th>Amount</th>
            <th>Rate</th>
            <th>Credit</th>
          </tr>
        </thead>
        <tbody>
          {credits.map((credit, idx) => (
            <tr key={idx}>
              <td>{credit.created_at}</td>
              <td>{credit.sender_id}</td>
              <td>{credit.amt}</td>
              <td>{credit.rate}</td>
              <td>{credit.units}</td>
            </tr>
          ))}
          <tr className="font-weight-bold bg-light">
            <td colSpan="2">Totals</td>
            <td>
              {credits.reduce((sum, c) => sum + parseFloat(c.amt || 0), 0).toFixed(2)}
            </td>
            <td>
             
            </td>
            <td>
              {credits.reduce((sum, c) => sum + parseFloat(c.units || 0), 0).toFixed(2)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

    </div>

    {/* Right Column */}
<div className="col-lg-4">
  <div className="card shadow-lg sticky-top border-0 rounded-4" style={{ top: '80px' }}>
    <div className="card-header bg-gradient-primary text-white rounded-top-4">
      <h4 className="mb-0"><i className="fas fa-paper-plane me-2"></i>Quick Message</h4>
    </div>
    <div className="card-body">
      <form onSubmit={sendSMS}>
        {/* Recipients */}
        <div className="mb-3">
          <label htmlFor="recipients" className="form-label fw-semibold">
            Recipients{" "}
            <span className="badge bg-danger-subtle text-danger ms-1">
              Type & Press Enter/Select From the List
            </span>
          </label>
          <Select
            id="recipients"
            options={contacts}
            isMulti
            placeholder="254XXXXXXXXX"
            value={smsData.phone_no.map((phone) => ({ value: phone, label: phone }))}
            onChange={(selected) => setSmsData({ ...smsData, phone_no: selected.map((opt) => opt.value) })}
            onInputChange={handleInputChange}
            inputValue={inputValue}
            onKeyDown={handleKeyDown}
            isSearchable
            className="select-input"
          />
        </div>

        {/* Subject */}
        <div className="mb-3">
          <label htmlFor="subject" className="form-label fw-semibold">
            <i className="fas fa-tag me-1 text-muted"></i>Subject
          </label>
          <input
            type="text"
            id="subject"
            className="form-control rounded-pill"
            placeholder="Subject"
            value={smsData.subject}
            onChange={handleSmsChange}
            required
          />
        </div>

        {/* Message */}
        <div className="mb-3">
          <label htmlFor="message_body" className="form-label fw-semibold">
            <i className="fas fa-comment-dots me-1 text-muted"></i>Message
          </label>
          <textarea
            id="message_body"
            className="form-control"
            rows={4}
            placeholder="Type your message here..."
            value={smsData.message_body}
            onChange={handleSmsChange}
            required
          />
        </div>

        {/* Stats */}
        <div className="d-flex justify-content-between align-items-center mb-3 small text-muted">
          <span><i className="fas fa-font me-1"></i>{remaining} characters left</span>
          <span><i className="fas fa-layer-group me-1"></i>{totalMessages} segment(s)</span>
        </div>

        {/* Submit */}
        <button
          type="submit"
          className="btn btn-primary w-100 shadow-sm rounded-pill"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <i className="fas fa-spinner fa-spin me-2"></i>Sending...
            </>
          ) : (
            <>
              <i className="fas fa-paper-plane me-2"></i>Send Message
            </>
          )}
        </button>
      </form>
    </div>
  </div>
</div>

  </div>
</div>
  );
  
};

export default Dashboard;
